<template>
  <div>
    <examination />
  </div>
</template>

<script>
import examination from "../../../components/adminComponent/coursemanagement/examination/examination";
export default {
  name: "Examination",
  components: {
    examination
  }
};
</script>

<style>
</style>